import { PureComponent } from 'react'
import { Field as FinalFormField } from 'react-final-form'

import { isDeepEqual } from '@/server-data'

import LoadsListField from './LoadsListField'
import { PublicProps as Props, FieldRenderProps } from './typings'

export default class LoadsFieldWrapper extends PureComponent<Props> {
  render() {
    const { name, ...props } = this.props

    return (
      <FinalFormField
        {...props}
        name={name}
        isEqual={isDeepEqual}
        render={(formProps: FieldRenderProps) => {
          return <LoadsListField {...this.props} formProps={formProps} />
        }}
      />
    )
  }
}
